<template lang="html">

  <section class="wrapper wrapper-view">

    <header class="header">

      <section class="row-between">
        <router-link to="/">
          <img style="max-width:220px !important; z-index:20;position: absolute;margin:10px;" :src="`/static/img/${logo}`" alt="Logo UFV">
        </router-link>
      </section>

      <h1 class="bottom header-ss">Política de privacidad Seguridad Social</h1>

    </header>

    <div class="divisor-ss"> 
    </div>

    <br>

    <div class="text-ss"> 
      <label class="text-ss-title">Información básica relativa a la protección de sus datos de carácter personal:</label>
      <div style=height:8px;></div><hr><div style=height:8px;></div>
      <label class="text-ss-text">El responsable del tratamiento de sus datos es la Universidad Francisco de Vitoria (UFV).</label><br>
      <label class="text-ss-text">Sus datos serán tratados con la finalidad principal de atender a su solicitud de prácticas académicas externas y realizar cuantas gestiones sean necesarias ante la Tesorería General de la Seguridad Social, siendo esta su base de legitimación del tratamiento en virtud del artículo 6.1.c del RGPD (el tratamiento es necesario para el cumplimiento de una obligación legal aplicable al responsable del tratamiento: disposición adicional quincuagésima segunda del Texto Refundido de la Ley General de la Seguridad Social).</label><br>
      <label class="text-ss-text">Le informamos que la UFV cederá sus datos personales para el cumplimiento de las finalidades anteriormente señaladas a la Tesorería General de la Seguridad Social, así como a los prestadores de servicios con acceso a datos. </label><br>
      <label class="text-ss-text">Los datos personales proporcionados se conservarán durante el plazo correspondiente para el cumplimiento de las obligaciones legales.</label><br>
      <label class="text-ss-text">Puede ejercitar sus derechos de acceso, rectificación, supresión, oposición, limitación del tratamiento y portabilidad mediante un escrito dirigido a la Secretaría General de la Universidad Francisco de Vitoria, Ctra. M-515 Pozuelo-Majadahonda Km. 1,800; 28223, Pozuelo de Alarcón (Madrid), o al correo electrónico <a target="_blank" href="mailto:dpd@ufv.es">dpd@ufv.es</a>.</label><br>
      <label class="text-ss-text">Si a través del presente formulario facilita datos de terceras personas, le informamos de que queda obligado a informar al interesado sobre el contenido de esta cláusula. El solicitante queda informado que no puede facilitar información que identifique a terceros sin obtener su consentimiento previo.</label><br>
      <label class="text-ss-text">Puede consultar la información ampliada en la web: <a target="_blank" href="https://www.ufv.es/politica-de-privacidad/">https://www.ufv.es/politica-de-privacidad/</a></label><br>
    </div>

    <br>

  </section>

</template>

<script lang="js">

  import Vue from 'vue';

  export default {
    name: 'politica-privacidad-seguridad-social',
    components: {},
    computed:{
      logo(){
        return 'logo-pye-ufv-w.png'
      }
    },
  }
</script>

<style scoped lang="scss">
  a{
    color: #72A3DC;
  }
  a:hover{
    text-decoration: underline;
  }
  .wrapper-view {padding: 0 !important;}

  .header-ss{    
    font-size: 2.5em;
    text-transform: uppercase;
    font-weight: 900;
    width: 100%;
    padding-bottom: 40px;
  }

  .divisor-ss{
    background: #003865;
    width: 100%;
    height: 40px;
  }

  @media screen and (max-width: 750px) {
    
    .header-ss{    
      font-size: 1.5em;
    }
  }

  @media screen and (max-width: 375px) {
    .header-ss{    
      font-size: 1em;
    }
  }

  .text-ss{
    padding: 25px 350px;
    text-align: left;
    color: #4A4A4A;
  }

  @media screen and (max-width: 1750px) {
    .text-ss{
    padding: 25px 250px;
    }
  }

  @media screen and (max-width: 1500px) {
    .text-ss{
    padding: 25px 200px;
    }
  }

  @media screen and (max-width: 850px) {
    .text-ss{
    padding: 25px 75px;
    }
  }

  @media screen and (max-width: 650px) {
    .text-ss{
    padding: 25px 20px;
    }
  }

  .text-ss-title{
    font-size: 1.3em;
    min-width: 100%;
    font-weight: 900
  }

  .text-ss-text{
    font-size: 1em;
    width: 100%;
    text-align: justify;
    display: block;
  }

</style>


// WEBPACK FOOTER //
// src/components/views/politica-privacidad-seguridad-social.vue